/**
 * RemarkCategoryHierarchyEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
import { RemarkCategoryHierarchyEntity } from "../RemarkCategoryHierarchyEntity";
import { ProjectEntity } from "../ProjectEntity";
import { RemarkEntity } from "../RemarkEntity";
declare global {
    interface EntityTypeMap {
        RemarkCategoryHierarchy: RemarkCategoryHierarchyEntity;
    }
}
export abstract class RemarkCategoryHierarchyGeneratedEntity extends BaseEntity {
    public abstract remarkCategoryHierarchyId: string;
    public abstract templateId: string | null;
    public abstract userOrder: number;
    public abstract category: RemarkCategoryEntity | null;
    public abstract parentHierarchy: RemarkCategoryHierarchyEntity | null;
    public abstract project: ProjectEntity;
    public abstract readonly children: ReadonlyArray<RemarkCategoryHierarchyEntity>;
    public abstract readonly remarks: ReadonlyArray<RemarkEntity>;
}
